module.exports = __webpack_public_path__ + "static/media/luisListing.023167de.JPG";